import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from './SignInPage';

// An unnamed blueprint instance under pluginId 'app' produces extension id
// `sign-in-page:app`, which is the built-in default's id — so this replaces it
// rather than sitting beside it.
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({ params: { loader: async () => SignInPage } }),
  ],
});
